import smartSolveApi from './instances/smartsolve';

export const getApiConfigurations = async () => {
  try {
    const response = await smartSolveApi.get('requests');

    return response.data;
  } catch (e) {
    throw new Error(`getConfigurations() failed: ${e}`);
  }
};

export const getExternalApiResults = async (dynamicParamCollection) => {
  try {
    const response = await smartSolveApi.post('/getsearchdata', { dynamicParamCollection });

    return response.data;
  } catch (e) {
    throw new Error(`getExternalApiResults() failed: ${e}`);
  }
};

export const fetchLocales = async () => {
  try {
    const response = await smartSolveApi.get('/external/locales');

    return response.data;
  } catch (e) {
    throw new Error(`getLocales() failed: ${e}`);
  }
};

export const fetchTimezones = async () => {
  try {
    const response = await smartSolveApi.get('/external/timezones');

    return response.data;
  } catch (e) {
    throw new Error(`getTimezones() failed: ${e}`);
  }
};
